export default {"src":"/_next/static/media/businessOldSocialMedia.b9d441a4.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};